interface CreateHTMLHeadLinkParams {
  rel: 'preload' | 'prefetch' | 'preconnect';
  href: string;
  /** @link https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel/preload#what_types_of_content_can_be_preloaded */
  as?: 'fetch' | 'image' | 'video';
  fetchpriority?: 'high' | 'low' | 'auto';
  /**
   * @link https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel/preload#including_a_mime_type
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types
   * */
  type?: string;
  crossorigin?: 'anonymous' | 'use-credentials';
}

/**
 * Создаёт link в head
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link
 */
export const createHTMLHeadLink = (params: CreateHTMLHeadLinkParams) => {
  const { href, as, rel, fetchpriority, type, crossorigin } = params;
  const linkEl = document.createElement('link');
  linkEl.rel = rel;
  linkEl.href = href;

  if (as) {
    linkEl.as = as;
  }

  if (type) {
    linkEl.type = type;
  }

  if (crossorigin) {
    linkEl.crossOrigin = crossorigin;
  }

  if (fetchpriority) {
    linkEl.setAttribute('fetchpriority', fetchpriority);
  }

  document.head.appendChild(linkEl);

  return linkEl;
};

type PreloadResourceParams = Pick<CreateHTMLHeadLinkParams, 'href' | 'type' | 'fetchpriority' | 'crossorigin'> & {
  as: CreateHTMLHeadLinkParams['as'];
};

export const preloadResource = (params: PreloadResourceParams) => {
  return createHTMLHeadLink({
    rel: 'preload',
    ...params,
  });
};

export const prefetchResource = (params: PreloadResourceParams) => {
  return createHTMLHeadLink({
    rel: 'prefetch',
    ...params,
  });
};

export const preconnectOrigin = (params: Pick<CreateHTMLHeadLinkParams, 'href'>) => {
  return createHTMLHeadLink({
    rel: 'preconnect',
    ...params,
  });
};
